import React, {useState} from 'react';
import images from "../../images";

const SelectableIntegrationCard = ({ integration, onSelect, isSelected = false }) => {
  const [copyNotificationVisible, setCopyNotificationVisible] = useState(false);

  const handleCopyUrl = () => {
    if (integration.url) {
      navigator.clipboard.writeText(integration.url)
        .then(() => {
          setCopyNotificationVisible(true);
          setTimeout(() => {
            setCopyNotificationVisible(false);
          }, 1500);
        })
        .catch(err => {
          console.error('Ошибка при копировании URL:', err);
        });
    }
  };

  const countParameters = Object.keys(integration.param || {}).filter(key => integration.param[key]).length;

  return (
    <div 
      className={`selectable-integration-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(integration)}
    >
      <div className="integration-card-header">
        <h3 className="integration-card-title">{integration.name}</h3>
      </div>

      <div className="integration-card-content">
        {integration.packages && integration.packages.length > 0 && (
            <div className="integration-packages">
              <strong>Пакеты:</strong>
              {integration.packages.join(', ')}
            </div>
        )}
        <div className="integration-flows-and-parameters">
          {integration.flows && integration.flows.length > 0 && (
            <div className="integration-flows">
              {integration.flows.map((flow, index) => (
                <span key={index} className="integration-flow-badge" style={{ backgroundColor: '#3745AF' }}>
                  {flow.flow_guide_name}
                </span>
              ))}
            </div>
          )}

          <div className="integration-parameters">
            {countParameters} параметора
          </div>
        </div>


        {integration.url && (
            <div
                className="integration-url"
                onClick={handleCopyUrl}
            >
              {integration.url}
              <img
                  src={images.copyLinear}
                  alt="copy"
                  className="copy-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyUrl();
                  }}
              />
            </div>
        )}
        {copyNotificationVisible && (
            <div className="copy-notification-overlay">
              Скопировано!
            </div>
        )}
      </div>
    </div>
  );
};

export default SelectableIntegrationCard;